import React from "react";

/**
 * Kleines Farbfeld je Farbton (Auftrag AP3 B). Ohne bekannten Farbwert ein
 * neutrales Streifenmuster statt einer geratenen Farbe oder eines leeren
 * Felds.
 */
export default function Farbfeld({farbwert, size = 20}) {
    const style = farbwert
        ? {backgroundColor: farbwert}
        : {
              backgroundImage: "repeating-linear-gradient(45deg, #dee2e6, #dee2e6 3px, #f1f3f5 3px, #f1f3f5 7px)",
          };

    return (
        <span
            aria-hidden="true"
            className="d-inline-block rounded-1 flex-shrink-0"
            style={{width: size, height: size, border: "1px solid rgba(0,0,0,.2)", ...style}}
        />
    );
}
